import { bizchatSidepaneStore } from '../store/store';

export function getIsPrecacheComplete(): boolean {
    return bizchatSidepaneStore().isPrecacheComplete;
}
